module.exports = {
  setEvent: (parent, target) => {
    if(!target) return;
    const radio = parent.querySelectorAll(`input[name="${target.name}"]`);
    radio.forEach((item, i) => {
      item.addEventListener('change',(e) => {
        const facedate = parent.querySelector(`.facephotodate`);
        if(e.target.value == '写真をアップロード'){
          facedate.classList.add('show');
        }else{
          facedate.classList.remove('show');
        }
      });
    });
  }
};
